import React from "react";
import PatientDatas from "src/modules/medcard/patient-datas";
import PartografForm from "../create";

function PartografList(props: any) {
  return (
    <>
      <PatientDatas showBloodPressureChart={false} showDailyPulseChart={false} />
      <PartografForm {...props} />
    </>
  );
}

export default PartografList;
